import {
  getValueByKey,
  getCheckbox,
  getBreadCrumbsProperties,
  getParsedHtmlValueByKey,
  getValueByKeyLp
} from "./UmbracoResource";

const exportedObject = {
  getValueByKey,
  getCheckbox,
  getBreadCrumbsProperties,
  getParsedHtmlValueByKey,
  getValueByKeyLp
};

export default exportedObject;
